import React from "react";
import {
  Flex,
  Text,
  Modal,
  Button,
  ModalBody,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { initialValues, useShipmentForm } from "context/DHLShipmentFormContext";

const ShipmentConfirmationModal = ({
  isOpen,
  onClose,
  onCloseSummaryModal,
}) => {
  const navigate = useNavigate();
  const {
    formData,
    updateFormData,
    setSelectToCountry,
    setSelectFromCountry,
    setSelectToCountryCode,
    setSelectFromCountryCode,
  } = useShipmentForm();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minW={"800px"}
        borderRadius={"16px"}
        p={6}
        alignSelf={"center"}
      >
        <ModalBody
          gap={4}
          display={"flex"}
          alignItems={"center"}
          flexDirection={"column"}
        >
          <Text
            fontSize={"24px"}
            fontFamily={"PlusJakartaSansSemiBold"}
            color={"#000000"}
            textAlign={"center"}
            textTransform={"capitalize"}
          >
            Shipment Confirmation
          </Text>
          <Text
            fontSize={"16px"}
            fontFamily={"PlusJakartaSansRegular"}
            color={"#000000"}
            textAlign={"center"}
            textTransform={"lowercase"}
          >
            Please drop off the bags in the selected location at your own
            convenience
          </Text>
          <Flex justifyContent={"center"} gap={3} pt={6}>
            <Button
              bg="#000000"
              borderRadius="12px"
              color="#FFFFFF"
              size="12px"
              fontSize={"12px"}
              fontFamily="PlusJakartaSansMedium"
              w={"358px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={() => {
                updateFormData(initialValues);
                setSelectFromCountry({});
                setSelectFromCountryCode({});
                setSelectToCountry({});
                setSelectToCountryCode({});
                onCloseSummaryModal();
                onClose();
                console.log("formData confirmation", formData);
                navigate("/send-a-bag/dhl/label-print");
                // if (formData?.dropoff?.howTo === "printer") {
                //   navigate("/send-a-bag/dhl/label-print");
                // } else {
                //   navigate("/send-a-bag");
                // }
              }}
            >
              CLOSE
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ShipmentConfirmationModal;
